<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper">
            <div id="Downloads">
                <h2>{{ $t('downloads.Header') }}</h2>
                <div id="Links">
                    <p><a href="https://nas.nwtu.eu/Downloads/NWTUAnmeldeSystemHandbuchDE.pdf" target="_blank">{{ $t('downloads.DescriptionDE') }}</a></p>
                    <p><a href="https://nas.nwtu.eu/Downloads/NWTUAnmeldeSystemManualEN.pdf" target="_blank">{{ $t('downloads.DescriptionEN') }}</a></p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        components: {

        },
        data: function () {
            return {

            };
        },
        computed: {

        },
        created: function () {

        },
        methods: {

        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
